import auth0 from 'auth0-js';
import jwtDecode from 'jwt-decode';

import {AUTH_CONFIG} from './config';

export enum Permission {
  Memberships = 'regionMemberships',
  Campaigns = 'regionCampaigns',
  Leads = 'regionLeads',
  Orders = 'regionOrders'
}

class Auth {
  tokenRenewalTimeout: any;
  auth0: any;
  userProfile: any;

  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.auth0 = new auth0.WebAuth({
      domain: AUTH_CONFIG.domain,
      clientID: AUTH_CONFIG.clientId,
      redirectUri: AUTH_CONFIG.callbackUrl,
      audience: AUTH_CONFIG.audience,
      responseType: 'token id_token',
      scope: 'openid'
    });

    this.scheduleRenewal();
  }

  login() {
    this.auth0.authorize();
  }

  async handleAuthentication() {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err: any, authResult: any) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.setSession(authResult);
          resolve();
        } else if (err) {
          console.error(err);
          alert(`Error: ${err.error}. Check the console for further details.`);
          reject(err);
        }
      });
    });
  }

  getAccessToken() {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      throw new Error('No access token found');
    }
    return accessToken;
  }

  getProfile(cb: any) {
    let accessToken = this.getAccessToken();
    this.auth0.client.userInfo(accessToken, (err: any, profile: any) => {
      if (profile) {
        this.userProfile = profile;
      }
      cb(err, profile);
    });
  }

  setSession(authResult: any) {
    let expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());

    // Set the time that the access token will expire at
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    // navigate to the admin route

    this.scheduleRenewal();
  }

  logout() {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');

    clearTimeout(this.tokenRenewalTimeout);
  }

  isAuthenticated() {
    /**
     * Check whether token exists
     */
    const token = localStorage.getItem('access_token');

    if (!token) {
      return false;
    }

    /**
     * Check it's expiration time
     */
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    // console.log(expiresAt);
    if (!expiresAt) {
      return false;
    }
    // console.log(new Date().getTime() < expiresAt);
    return new Date().getTime() < expiresAt;
  }

  scheduleRenewal() {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    const delay = expiresAt - Date.now();
    if (delay > 0) {
      this.tokenRenewalTimeout = setTimeout(() => {
        this.renewToken();
      }, delay);
    }
  }

  renewToken() {
    this.auth0.checkSession(
      {
        audience: AUTH_CONFIG.audience,
        scope: 'openid'
      },
      (err: any, result: any) => {
        if (err) {
          alert('Error occurred. Open app new window' + JSON.stringify(err));
        } else {
          this.setSession(result);
        }
      }
    );
  }

  isUserAdmin(idToken: string) {
    if (idToken) {
      const tokenDecoded = jwtDecode(idToken);

      return (
        tokenDecoded['http://memberjourneyhub.com/backoffice/roles'] &&
        tokenDecoded['http://memberjourneyhub.com/backoffice/roles'].some((role: any) => role === 'admin')
      );
    }
    return false;
  }

  getRoles(): Array<string> {
    const token = localStorage.getItem('id_token');
    if (token) {
      const tokenDecoded = jwtDecode(token);
      return tokenDecoded['http://memberjourneyhub.com/backoffice/roles'];
    }
    return [];
  }
}

const auth = new Auth();
export default auth;



// WEBPACK FOOTER //
// ./src/utils/auth/index.tsx